import { render, staticRenderFns } from "./AuthenticationCardLogo.vue?vue&type=template&id=c2d3c5c4&"
import script from "./AuthenticationCardLogo.vue?vue&type=script&lang=js&"
export * from "./AuthenticationCardLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports